var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-to-top w-100 text-right",on:{"click":_vm.scrolltoTop}},[_c('img',{ref:"backtoTopButton",staticClass:"invisible",attrs:{"src":require("@/assets/icons/back-to-top.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }